import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar'
import Footer from '../components/Layout/Footer'
import ChromiumOxide from "../asset/coating/chromium.png";
import Hardchrome from "../asset/coating/hardchrome.png";
import Nitriding from "../asset/coating/nitriding.png";
import Cadmium from "../asset/coating/cadmium.png";
import Diamond from "../asset/coating/diamond.png";
import Zinc from "../asset/coating/zinccoating.png";
import "./ProductDetail.css";

const coatings = [
  ["Chromium oxide coated components", ChromiumOxide],
  ["Hard chrome plating components", Hardchrome],
  ["Nitriding components", Nitriding],
  ["Cadmium plating components", Cadmium],
  ["Diamond-like coating (DLC) components", Diamond],
  ["Zinc-phosphating coating", Zinc],
];

const CoatingandPlating = () => {
  return (
    <div className="product-detail-page product-detail-page--coating">
    <NavbarTwo />
    <main className="product-detail-page__main">
      <section className="product-detail-intro product-detail-intro--centered">
        <h2>COATING AND PLATING</h2>
        <p>At HARDCOATS, we specialize in high-quality precision components with advanced plating and coating solutions, including chromium oxide coating, hard chrome plating, nitriding, cadmium plating, DLC coating and zinc-phosphating. We handle the critical pre- and post-machining stages in-house and work with trusted approved vendors for coating processes.</p>
      </section>
      <section className="product-detail-gallery" aria-label="Coating and plating capabilities">
        {coatings.map(([title, image]) => (
          <article className="product-detail-gallery__card" key={title}>
            <div><img src={image} alt={title} /></div>
            <h3>{title}</h3>
          </article>
        ))}
      </section>
    </main>
    <Footer />
  </div>
  )
}

export default CoatingandPlating
